import Vue from 'vue'
import VueRouter from 'vue-router'
import { Title } from '@/config'
import store from '@/store'
import routes from './routes'
import { AXIOS_RESET,CLEAR_TOKEN } from '../store/mutation-types'
Vue.use(VueRouter)

const router = new VueRouter({ mode: 'history', base: '/', routes })

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // 重置 axios 状态
  // store.commit(CLEAR_TOKEN) //去除登录状态

  // 是否有管理token
  const isLogin = localStorage.getItem('token');
  if(isLogin&&to.name=='login'){
    window.location.href = "/index/main";
    return;
  }
  // const query = from.name === null ? to.query : from.query

  // if (!router.getMatchedComponents(to).length) {
  //   const name = isLogin ? 'home' : 'login'
  //   return next({ name, query })
  // }

  // // 是否去到登陆页面
  // const toLogin = to.name === 'login'

  // // 已登陆不得去往登陆页，转至首页
  // if (toLogin && isLogin) {
  //   return next({ name: 'home', query })
  // }

  // // 未登陆不得去往非登录页，转至登录页
  // if (!toLogin && !isLogin) {
  //   // return next({ name: 'login', query })
  //   next()
  // }

  // 重置标题
  if (to.meta.title) {
    document.title = Title.make(to.meta.title, to.params)
  }

  next()
})

export default router
